import React, { useEffect } from 'react';
import styled from 'styled-components';
import randomColor from 'randomcolor';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { _GetPost } from '../../store/actions/blogAction';
import Loading from '../../components/loading/Loading';
import { Error } from '../../components/error/Error';
import './blog.css';

export const Blog = () => {
  const dispatch = useDispatch();

  const { loading, posts, error } = useSelector((state) => state.blog);

  useEffect(() => {
    dispatch(_GetPost());
  }, []);

  const color = randomColor({
    count: 10,
    luminosity: 'light',
    hue: 'random',
  });

  const IsLoading = () => {
    if (loading) {
      return <Loading/>
    }
  };

  const IsError = () => {
    if (error) {
      return <Error/>
    }
  };

  return (
    <BlogPageWrap>
      <section className='blog__page'>
        <div className='container'>
          <h1 className='blog__page__title'>Tips and Tricks</h1>
          <div className='blog__headline'>
            <p className='blog__headline__text'>
              {' '}
              I write about my experiences and tips for web development and
              mobile development. My goal is to share my knowledge and
              experience with others. I focus on technologies like JavaScript,
              React, Node, Express, MongoDB, TypeScript and more.{' '}
            </p>
          </div>
          <div className='blog__page__content'>
            {IsLoading()}
            {IsError()}
            {posts.length !== 0 &&
              posts.blogs.map((ele) => {
                const {
                  _id,
                  content,
                  title,
                  category,
                  tags,
                  created,
                  featuredImage,
                } = ele;
                return (
                  <Link
                    to={`/post/${_id}`}
                    key={_id}
                    className='wrapper blog__page__content__item'
                  >
                    <div className='blog__page__content__item__img'>
                      <span>{category}</span>
                      <img src={featuredImage} alt={title} />
                    </div>
                    <div className='blog__page__content__text_wrap'>
                      <div className='blog__page__content__item__text'>
                        <h3 className='blog__page__content__item__text__title'>
                          {title}
                        </h3>
                        <p className='timestamp'>
                          Created <span>{moment(created).fromNow()}</span>{' '}
                        </p>

                        <Editor
                          editorClassName='blog__page__content__item__text__desc'
                          editorState={
                            content
                              ? EditorState.createWithContent(
                                  ContentState.createFromBlockArray(
                                    htmlToDraft(
                                      content.substring(0, 50) + `...`
                                    )
                                  )
                                )
                              : EditorState.createEmpty()
                          }
                          readOnly
                          toolbarHidden
                        />
                        <div className='blog__page__content__item__button tags'>
                          <span>tags: </span>
                          {tags.map((ele, index) => {
                            return (
                              <ul key={index}>
                                <li
                                  style={{
                                    background: `${
                                      index === 0
                                        ? color[0]
                                        : index === 1
                                        ? color[3]
                                        : index === 2
                                        ? color[2]
                                        : index === 3
                                        ? color[6]
                                        : index === 4
                                        ? color[9]
                                        : color[8]
                                    }`,
                                  }}
                                >
                                  {ele}
                                </li>
                              </ul>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </Link>
                );
              })}
          </div>
        </div>
      </section>
    </BlogPageWrap>
  );
};

const BlogPageWrap = styled.main`
  padding: 2rem;
  position: relative;
  z-index: 1;
  margin-top: 5rem;

  @media (max-width: 768px) {
    padding: 0;

    .blog__page__content {
      margin: 30px !important;
    }

    .blog__page__content__item {
      min-width: 300px !important;
      width: 30% !important;
    }
  }

  .blog__page {
    width: 100%;
    height: auto;
    clear: both;
    min-height: 100%;
  }

  .wrapper {
    text-decoration: none;
    cursor: pointer;
  }
  .blog__page__title {
    text-align: center;
    color: ${({ theme }) => theme.text};
    font-size: 45px;
    font-weight: 800;
    line-height: 1.4;
    text-transform: uppercase;
    margin-bottom: 25px;
  }

  .blog__headline__text {
    font-size: 18px;
    line-height: 1.4;
    color: ${({ theme }) => theme.text};
    margin-bottom: 25px;
    text-align: center;
  }

  .blog__page__content {
    height: auto;
    min-height: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    margin: 50px;
  }

  .blog__page__content__item {
    border-radius: 15px;
    box-shadow: 0px 0px 10px #00000054;
    color: ${({ theme }) => theme.text};
    margin: 15px;
    min-width: 200px;
    width: 30%;
  }

  .blog__page__content__item__img {
    width: 100%;
    position: relative;
  }

  .blog__page__content__item__img span {
    position: absolute;
    top: 10px;
    left: 10px;
    background-color: ${({ theme }) => theme.svg};
    padding: 5px 10px;
    border-radius: 5px;
    color: ${({ theme }) => theme.pale};
    font-size: 14px;
    font-weight: 800;
    text-transform: capitalize;
  }

  .blog__page__content__item__img img {
    width: 100%;
    height: 250px;
    object-fit: cover;
    border-radius: 15px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  .blog__page__content__text_wrap {
    padding: 1rem;
  }

  .timestamp {
    font-size: 12px;
    color: ${({ theme }) => theme.projText};
    margin-bottom: 5px;
    font-weight: 700;
  }

  .tags {
    width: 100%;
    align-self: flex-end;
    position: relative;
  }

  .tags ul {
    display: inline-flex;
    flex-direction: row !important;
    justify-content: flex-start;
    text-align: center;
    text-transform: capitalize;
  }

  .tags ul li {
    margin: 5px;
    padding: 0;
    font-size: 0.7rem;
    font-weight: 700;
    border-radius: 6px;
    padding: 6px 10px;
    list-style: none;
    color: ${({ theme }) => theme.dark};
    box-shadow: 0 5px 15px ${({ theme }) => theme.gradient};
  }
`;
